export const ONBOARDING_AUTH_STORAGE_KEY = 'onboarding-auth'

export type RegistrationAuthSession = {
  accessToken: string
  refreshToken: string | null
  /**
   * The signed-in user's subject, as returned by the registration API.
   *
   * Optional so storage written before this field existed can still be parsed
   * and cleared through the onboarding recovery path.
   */
  sub?: string | null
}

const isRegistrationAuthSession = (
  value: unknown
): value is RegistrationAuthSession => {
  if (!value || typeof value !== 'object') return false

  const session = value as Partial<RegistrationAuthSession>

  return (
    typeof session.accessToken === 'string' &&
    (typeof session.refreshToken === 'string' || session.refreshToken === null)
  )
}

export const getStoredRegistrationAuthSession =
  (): RegistrationAuthSession | null => {
    try {
      const stored = window.localStorage.getItem(ONBOARDING_AUTH_STORAGE_KEY)
      if (!stored) return null

      const parsed = JSON.parse(stored) as unknown

      return isRegistrationAuthSession(parsed) ? parsed : null
    } catch {
      return null
    }
  }

export const storeRegistrationAuthSession = (
  session: RegistrationAuthSession
) => {
  try {
    window.localStorage.setItem(
      ONBOARDING_AUTH_STORAGE_KEY,
      JSON.stringify(session)
    )
  } catch {
    return
  }
}

export const clearRegistrationAuthSession = () => {
  try {
    window.localStorage.removeItem(ONBOARDING_AUTH_STORAGE_KEY)
  } catch {
    return
  }
}
